import { Injectable } from '@angular/core';
import { BoardSoftPosAdyenTerminal } from './terminal.actions';
import { AdyenSoftPosInfo } from '@core/services/system/adyen/classes';
import { AdyenSoftPosService } from '@core/services/system/adyen/services/adyen-soft-pos.service';
import { Store } from '@ngrx/store';
import { AdyenSoftPosTargetAction } from '@core/services/system/adyen/enums';

@Injectable()
export class SettingsStateFacade {

  constructor(
    private adyenSoftPosService: AdyenSoftPosService,
    private store: Store
    ) { }

  public boardSoftPosAdyen(params: Record<string, string>): void {
    const { boarded, boardingRequestToken, installationId, target } = params;
    this.store.dispatch(BoardSoftPosAdyenTerminal({
      info: new AdyenSoftPosInfo(
        boarded,
        installationId,
        boardingRequestToken
      ),
      target: target as AdyenSoftPosTargetAction
    }));
  }

  public actionAdyenSoftPosTerminal(params: Record<string, string>, url: URL): void {
    const softPOSAction: AdyenSoftPosTargetAction = this.adyenSoftPosService.gettingTargetActionSoftPos(url) as AdyenSoftPosTargetAction;

    switch (softPOSAction) {

      case AdyenSoftPosTargetAction.Payment: {
        const hasError: boolean = !!params?.['error'];
        const response: string = params?.['response'] || params?.['error'] || '';
        // Fire and forget by design — the result travels back through the payment subject, not this
        // promise. The catch only exists so a rejection cannot become an unhandled one; the service
        // has already routed the failure to the waiting payment.
        this.adyenSoftPosService.setResultPaymentFromSoftPos(response, hasError).catch(() => {});
      } break;

      default: {
        this.boardSoftPosAdyen({
          ...params,
          target: softPOSAction
        });
      }

    }
  }

}
